import Axios from "axios";
var SalesReportService = (function () {
    function SalesReportService() {
    }
    SalesReportService.prototype.getList = function (params) {
        return Axios.get("supplierclientapi/stockinit/list", { params: params });
    };
    SalesReportService.prototype.getSaleDetailReportList = function (params) {
        return Axios.post("supplierclientapi/sale_report/sale_detail_report", params);
    };
    SalesReportService.prototype.updateExport = function (params) {
        return Axios.post("supplierclientapi/export/update", params);
    };
    SalesReportService.prototype.getExportDetail = function (params) {
        return Axios.get("supplierclientapi/export/detail", { params: params });
    };
    SalesReportService.prototype.updateExportSummaryReport = function (params) {
        return Axios.post("supplierclientapi/XXX", params);
    };
    SalesReportService.prototype.getExportSummaryReport = function (params) {
        return Axios.get("supplierclientapi/XXXX", { params: params });
    };
    SalesReportService.prototype.saleReportAsyncExport = function (params) {
        return Axios.get("supplierclientapi/sale_report/async_export", { params: params });
    };
    SalesReportService.prototype.getSummaryList = function (params) {
        return Axios.get("supplierclientapi/sale_report_summary/index", { params: params });
    };
    SalesReportService.prototype.getSummaryShopList = function (params) {
        return Axios.get("supplierclientapi/sale_report_summary/list_shop", { params: params });
    };
    SalesReportService.prototype.getSummaryDepotList = function (params) {
        return Axios.get("supplierclientapi/sale_report_summary/list_depot", { params: params });
    };
    SalesReportService.prototype.getSummaryDepotDetail = function (params) {
        return Axios.get("supplierclientapi/sale_report_summary/list_depot_detail", { params: params });
    };
    SalesReportService.prototype.getGoodsCategoryList = function (params) {
        return Axios.get("supplierclientapi/sale_report_summary/list_goods_type", { params: params });
    };
    SalesReportService.prototype.getGoodsList = function (params) {
        return Axios.get("supplierclientapi/sale_report_summary/list_by_goods", { params: params });
    };
    SalesReportService.prototype.getGoodsCategoryDetail = function (params) {
        return Axios.get("supplierclientapi/sale_report_summary/list_goods_type_detail", { params: params });
    };
    SalesReportService.prototype.getGoodsDetail = function (params) {
        if (params && params.hasOwnProperty("keywords")) {
            delete params.keywords;
        }
        return Axios.get("supplierclientapi/sale_report_summary/list_by_goods_detail", { params: params });
    };
    SalesReportService.prototype.getbusinessStock = function (params) {
        return Axios.get("supplierclientapi/customer/show_business_stock_list", { params: params });
    };
    SalesReportService.prototype.getbusinessArea = function (params) {
        return Axios.get("basicapi/customer_area", { params: params });
    };
    SalesReportService.prototype.getClientType = function (params) {
        return Axios.get("supplierclientapi/customer/shop_type_list", { params: params });
    };
    SalesReportService.prototype.getClientStore = function (params) {
        return Axios.get("supplierclientapi/shop/condition_shop_list", { params: params });
    };
    SalesReportService.prototype.getClientGoodsType = function (params) {
        return Axios.get("basicapi/business_goodstype", { params: params });
    };
    SalesReportService.prototype.getBusinessStockList = function (params) {
        return Axios.get("supplierclientapi/report/business_stock_list", { params: params });
    };
    SalesReportService.prototype.getListShopDetail = function (params) {
        return Axios.get("supplierclientapi/sale_report_summary/list_shop_by_goods_detail", { params: params });
    };
    SalesReportService.createInstance = function () {
        SalesReportService.getInstance();
    };
    SalesReportService.getInstance = function () {
        return this._instance || (this._instance = new this());
    };
    return SalesReportService;
}());
export default SalesReportService;
